module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/landing/homepage-476e3e79180d43b666bb4435da5f74f7.jpg";